// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShortcutTerm__term___Bs8H9 {
    display: flex;
    gap: var(--space-2xs);
    align-items: center;
    justify-self: end;

    padding: 0.3rem 1rem;

    color: var(--color-control-typo-ghost);
    text-wrap: nowrap;

    background-color: var(--color-control-bg-ghost);
    border-radius: var(--control-radius);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/ShortcutsPanel/ShortcutTerm/ShortcutTerm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;;IAEjB,oBAAoB;;IAEpB,sCAAsC;IACtC,iBAAiB;;IAEjB,+CAA+C;IAC/C,oCAAoC;AACxC","sourcesContent":[".term {\n    display: flex;\n    gap: var(--space-2xs);\n    align-items: center;\n    justify-self: end;\n\n    padding: 0.3rem 1rem;\n\n    color: var(--color-control-typo-ghost);\n    text-wrap: nowrap;\n\n    background-color: var(--color-control-bg-ghost);\n    border-radius: var(--control-radius);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"term": `ShortcutTerm__term___Bs8H9`
};
export default ___CSS_LOADER_EXPORT___;
